var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { selectBalancingCharacter } from "../balancingSelectors/selectBalancingCharacters";
import { selectBalancingMarketUnlockLevel } from "../balancingSelectors/selectBalancingConstants";
import { selectBalancingContractOrder } from "../balancingSelectors/selectBalancingContractOrders";
import { selectBalancingContractRewardsById } from "../balancingSelectors/selectBalancingContractRewards";
import { selectResourceAmountInfo } from "../balancingSelectors/selectBalancingResources";
import { IdPersistence } from "../constants/IdPersistence";
import { XpCategory } from "../features/market/XpCategory";
import { utilMarket } from "../utils/market/utilMarket";
import { BuffTargetType } from "../utils/network/generated/protoTypes";
import { utilPersistence } from "../utils/utilPersistence";
import { selectContractRevenueBuffAmount, selectContractXpBuffAmount } from "./selectBuffsInfo";
import { selectInventoryResourceInfo } from "./selectInventoryInfo";
export var selectContractInfo = function (state) {
    if (!state.contractInfo.contract || state.contractInfo.contract.length === 0) {
        return;
    }
    return state.contractInfo.contract.map(function (contract) {
        var visualId = contract.visualId;
        var visualInfo = selectBalancingCharacter(visualId);
        var rewardId = contract.rewardId;
        var rewardInfo = selectBalancingContractRewardsById(rewardId);
        var orderId = contract.orderId;
        var orderInfo = orderId.map(function (id) { return selectBalancingContractOrder(id); });
        return __assign({ contractId: contract.contractId, orders: orderInfo, reward: rewardInfo, visual: visualInfo }, (contract.remainingTime && { remainingTime: contract.remainingTime }));
    });
};
export var selectContractRewardInfo = function (state) {
    var contractsInfo = selectContractInfo(state);
    if (!contractsInfo) {
        return;
    }
    return contractsInfo.map(function (_a) {
        var reward = _a.reward, orders = _a.orders, contractId = _a.contractId;
        var rewardInfo = {
            adventureXp: 0,
            buffAdventureXpAmount: Long.ZERO,
            buffMarketXpAmount: Long.ZERO,
            buffPlayerXpAmount: Long.ZERO,
            contractId: contractId,
            marketXp: 0,
            playerXp: 0,
            rewards: [],
        };
        if (reward && reward.reward) {
            reward.reward.forEach(function (rew) {
                var resourceAmount = utilMarket.getContractXp(orders, rew);
                switch (rew.resourceId) {
                    case XpCategory.Player:
                        rewardInfo.playerXp = resourceAmount;
                        rewardInfo.buffPlayerXpAmount = Long.fromValue(selectContractXpBuffAmount(state, BuffTargetType.XP, rewardInfo.playerXp));
                        break;
                    case XpCategory.Market:
                        rewardInfo.marketXp = resourceAmount;
                        rewardInfo.buffMarketXpAmount = Long.fromValue(selectContractXpBuffAmount(state, BuffTargetType.MARKET_XP, rewardInfo.marketXp));
                        break;
                    case XpCategory.Adventure:
                        rewardInfo.adventureXp = resourceAmount;
                        rewardInfo.buffAdventureXpAmount = Long.fromValue(selectContractXpBuffAmount(state, BuffTargetType.ADVENTURER_XP, rewardInfo.adventureXp));
                        break;
                    default:
                        var otherRewards = selectResourceAmountInfo(rew.resourceId, resourceAmount);
                        otherRewards.buffAmount = Long.fromValue(selectContractRevenueBuffAmount(state, rew.resourceId, resourceAmount));
                        rewardInfo.rewards.push(otherRewards);
                }
            });
        }
        return rewardInfo;
    });
};
export var selectContractRewardInfoById = function (state, id) {
    var contractsRewardInfo = selectContractRewardInfo(state);
    if (!contractsRewardInfo) {
        return;
    }
    return contractsRewardInfo.find(function (contractRewardInfo) { return contractRewardInfo.contractId === id; });
};
export var selectContractById = function (state, contractId) {
    if (!state.contractInfo.contract) {
        return;
    }
    return state.contractInfo.contract.find(function (contract) { return contract.contractId === contractId; });
};
export var selectContractOrder = function (state, contractId) {
    var contract = state.contractInfo.contract.find(function (ct) { return ct.contractId === contractId; });
    if (contract && contract.orderId) {
        return contract.orderId.map(function (oid) { return selectBalancingContractOrder(oid); });
    }
    else {
        return;
    }
};
export var selectIsQualifiedForMarket = function (state) {
    if (state.playerInfo && state.playerInfo.level) {
        return state.playerInfo.level >= selectBalancingMarketUnlockLevel();
    }
    else {
        return false;
    }
};
export var selectHasFulfillableContract = function (state) {
    var contractsInfo = selectContractInfo(state);
    if (contractsInfo) {
        return contractsInfo.some(function (contract) {
            if (contract.remainingTime || 0 > 0) {
                return false;
            }
            var orders = contract.orders.map(function (order) {
                var inventoryResource = selectInventoryResourceInfo(state, order.resourceId);
                var total = inventoryResource ? inventoryResource.amount : Long.ZERO;
                return __assign({}, order, { total: total });
            });
            return orders.every(utilMarket.contractOrderFulfillable);
        });
    }
    return false;
};
export var selectContractCooldownTime = function () {
    return utilPersistence.getValue(IdPersistence.ContractData, {
        cooldownTime: 0,
    });
};
export var selectContractMissingResources = function (state, contractId) {
    var orderResources = selectContractOrder(state, contractId);
    if (!orderResources) {
        return [];
    }
    return orderResources.reduce(function (missingResources, order) {
        var playerResource = selectInventoryResourceInfo(state, order.resourceId);
        var playerResourceAmount = playerResource.amount || Long.ZERO;
        if (playerResourceAmount.lessThan(Long.fromValue(order.amount))) {
            missingResources.push({
                amount: Long.fromValue(order.amount).subtract(playerResourceAmount),
                typeId: order.resourceId,
            });
        }
        return missingResources;
    }, []);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectContractInfo.ts
// module id = 164
// module chunks = 3